export const requestCache = new Map();
export const inFlightRequests = new Map();

export const clearInfluencerMarketplaceCache = () => {
  requestCache.clear();
  inFlightRequests.clear();
};

export default clearInfluencerMarketplaceCache;
